module.exports = {"id":"184431","name":"Sebastian Giovinco","rating":"83","photo":"./data/images/photos/3/184431.png","club":{"name":"Toronto FC","logo":"./data/images/clubs/TorontoFC.png"},"positions":["ATT","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SebastianGiovinco0.json
// module id = 3859
// module chunks = 0